export class ExternalSearchVariablesWebhook {
    cns: string; 
    cpf: string;
    insuranceNumber : string;
}